import { Link } from 'react-router-dom';
import { ArrowRight, FileCheck2, GraduationCap, ShieldCheck, Globe, Layers, Eye, Handshake, Timer } from 'lucide-react';
import PageHeader from '../components/PageHeader';
import SectionHeading from '../components/SectionHeading';
import { FadeUp } from '../components/Reveal';
import Marquee from '../components/Marquee';
import { differentials, normsMarquee } from '../data/site';

const ICONS = {
  fileCheck: FileCheck2,
  graduation: GraduationCap,
  shield: ShieldCheck,
  globe: Globe,
  layers: Layers,
  eye: Eye,
  handshake: Handshake,
  timer: Timer,
};

export default function Diferenciais() {
  return (
    <>
      <PageHeader
        index="05"
        eyebrow="Diferenciais"
        title="Por que o Grupo Majo?"
        description="Não entregamos apenas serviços: entregamos responsabilidade técnica, conformidade legal e parceria de verdade do primeiro contato ao documento final."
      />
      <Marquee items={normsMarquee} />

      <section className="mx-auto max-w-7xl px-5 py-24 lg:px-8 lg:py-28" data-testid="differentials-grid">
        <SectionHeading
          eyebrow="Nossos Diferenciais"
          title="Engenharia consultiva, do orçamento ao Habite-se"
        />
        <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          {differentials.map((d, i) => {
            const Icon = ICONS[d.icon];
            return (
              <FadeUp key={d.title} delay={(i % 4) * 0.08}>
                <article className="card-hover flex h-full flex-col rounded-2xl surface p-7" data-testid={`differential-card-${i}`}>
                  <div className="grid h-12 w-12 place-items-center rounded-xl bg-navy text-gold-light transition-colors duration-300 hover:bg-gold hover:text-navy-deep dark:bg-white/10">
                    <Icon size={22} strokeWidth={1.8} />
                  </div>
                  <h3 className="mt-5 font-display text-base font-bold leading-snug text-navy dark:text-white">{d.title}</h3>
                  <p className="mt-3 flex-1 text-sm leading-relaxed text-muted-c">{d.text}</p>
                  <span className="mt-5 block font-display text-3xl font-extrabold outline-numeral" aria-hidden="true">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                </article>
              </FadeUp>
            );
          })}
        </div>
      </section>

      <section className="relative overflow-hidden bg-navy py-24 text-white" data-testid="differentials-art-band">
        <div className="absolute inset-0 bg-blueprint" aria-hidden="true" />
        <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
          <div className="grid items-center gap-12 lg:grid-cols-2">
            <FadeUp>
              <p className="font-display text-[7rem] font-extrabold leading-none text-gold-light md:text-[10rem]">100%</p>
              <p className="mt-2 font-display text-2xl font-bold md:text-3xl">dos serviços com ART registrada no CREA</p>
            </FadeUp>
            <FadeUp delay={0.15}>
              <p className="leading-relaxed text-white/70 md:text-lg">
                A Anotação de Responsabilidade Técnica é a prova formal de que um engenheiro legalmente habilitado responde pelo serviço executado. No Grupo Majo, nenhuma obra, laudo ou projeto é entregue sem a sua ART — garantia de respaldo jurídico para prefeituras, condomínios, seguradoras e comitês de auditoria.
              </p>
              <Link to="/simulador" data-testid="differentials-cta" className="btn-gold mt-9">
                Garantir minha ART <ArrowRight size={16} />
              </Link>
            </FadeUp>
          </div>
        </div>
      </section>
    </>
  );
}
